import ToggleButtonUI from "./ToggleButtonUI";

type PropsType = {
  section?: string;
  setMetric: () => void;
  setImperial: () => void;
  selectedUnit?: string;
  className?: string;
  readOnly?: boolean;
};
const ToggleAllUnitsButton = ({
  section,
  setMetric,
  setImperial,
  selectedUnit,
  className,
  readOnly,
}: PropsType) => {
  const fieldId = (value: string) => `${section}-toggle-all-units-${value}`;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === fieldId("imperial")) setImperial();
    if (event.target.value === fieldId("metric")) setMetric();
  };

  return (
    <ToggleButtonUI
      value={selectedUnit ? fieldId(selectedUnit) : selectedUnit}
      leftOption={{
        inputProps: { onChange },
        label: "Metric",
        value: fieldId("metric"),
      }}
      rightOption={{
        inputProps: { onChange },
        label: "Imperial",
        value: fieldId("imperial"),
      }}
      className={className}
      readOnly={readOnly}
      controlled
    />
  );
};

export default ToggleAllUnitsButton;
